import { setTitlePrefix } from '@/portainer/helpers/titleHelper';
import { SettingsViewModel, PublicSettingsViewModel } from '../../models/settings';

angular.module('portainer.app').factory('SettingsService', [
  '$q',
  'Settings',
  function SettingsServiceFactory($q, Settings) {
    'use strict';
    var service = {};

    var whitelabelChecked = false;

    service.settings = function () {
      var deferred = $q.defer();

      Settings.get()
        .$promise.then(function success(data) {
          var settings = new SettingsViewModel(data);
          deferred.resolve(settings);
        })
        .catch(function error(err) {
          deferred.reject({ msg: 'Unable to retrieve application settings', err: err });
        });

      return deferred.promise;
    };

    service.update = function (settings) {
      return Settings.update({}, settings).$promise;
    };

    service.publicSettings = function () {
      var deferred = $q.defer();

      Settings.publicSettings()
        .$promise.then(function success(data) {
          var settings = new PublicSettingsViewModel(data);
          service.checkWhitelabel(data.Whitelabel);
          deferred.resolve(settings);
        })
        .catch(function error(err) {
          deferred.reject({ msg: 'Unable to retrieve application settings', err: err });
        });

      return deferred.promise;
    };

    service.checkLDAPConnectivity = function (settings) {
      return Settings.checkLDAPConnectivity({}, settings).$promise;
    };

    service.checkWhitelabel = function (whitelabel) {
      // Make sure we only run this check once
      if (whitelabelChecked) {
        return;
      }
      whitelabelChecked = true;

      // If we're not whitelabeled, inject the Portainer favicons
      if (!whitelabel) {
        const template = document.getElementById('favicons-template');
        const favicons = template.content.cloneNode(true);
        document.head.appendChild(favicons);
      }

      // Set the title
      setTitlePrefix(whitelabel || 'Portainer');
    };

    return service;
  },
]);
